import { DatePicker, LocalizationProvider } from '@mui/lab';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import {
  Box,
  Container,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Page from 'components/Page';
import React, { useState } from 'react';
import color from 'styles/color';
import { Table, Td, Th, Tr } from 'components/Table';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QueryString from 'qs';
import useQueryParam from 'hook/useQueryParam';
import dayjs from 'dayjs';
import useSettlementDetail from 'hook/useSettlementDetail';
import {
  SettlementsStatus,
  SettlementsStatusColor,
  SETTLEMENTS_STATUS,
} from 'model/Settlements';
import useCoachList from 'hook/useCoachList';
import useCoachChallenge from 'hook/useCoachChallenge';
import commaNumber from 'comma-number';
import { RootStyle } from './style';

export function CashDetail() {
  const { id } = useParams();
  const { year, month, coachId } = useQueryParam();
  const coachList = useCoachList();
  const [date, setValue] = useState<Date>(
    dayjs()
      .year(Number(year))
      .month(Number(month) - 1)
      .toDate(),
  );
  const { data, sales } = useSettlementDetail({
    year: Number(date.getFullYear()),
    month: Number(date.getMonth()) + 1,
    coachId: Number(coachId),
    challengeId: Number(id),
  });

  const [coach, setCoach] = useState(coachId);
  const [program, setProgram] = useState(id);
  const coachChallenges = useCoachChallenge({
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    userId: Number(coach),
  });

  const currencies = [
    {
      value: '2022.01',
      label: '2022.01',
    },
    {
      value: '2022.01',
      label: '2022.01',
    },
    {
      value: '2022.01',
      label: '2022.01',
    },
    {
      value: '2022.01',
      label: '2022.01',
    },
  ];

  const navigate = useNavigate();
  return (
    <Box>
      <Container style={{ width: '100%' }}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
          mt={4}
        >
          <Typography variant='h4' gutterBottom>
            상세 내역
          </Typography>
        </Stack>
        <Stack direction='row' spacing={2} mb={5}>
          <Box>
            <TextField
              id='outlined-select-currency'
              select
              label='Select'
              value={coach}
              style={{ width: '300px' }}
              onChange={(event) => setCoach(event.target?.value)}
            >
              {coachList.data?.items.map((option) => (
                <MenuItem key={option.user_id} value={option.user_id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box flex={1}>
            <TextField
              id='outlined-select-currency'
              select
              label='Select'
              value={program}
              style={{ width: '300px' }}
              onChange={(event) => {
                setProgram(event.target?.value);
                navigate(
                  `/cash/challenge${event.target?.value}${QueryString.stringify(
                    {
                      year,
                      month,
                      coachId: coach,
                    },
                    { addQueryPrefix: true },
                  )}`,
                );
              }}
            >
              {coachChallenges.data?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                views={['month', 'year']}
                label='Year and Month'
                minDate={new Date('2012-03-01')}
                maxDate={new Date('2050-06-01')}
                value={date}
                onChange={(newValue) => {
                  setValue(newValue as Date);
                }}
                renderInput={(params) => (
                  <TextField {...params} helperText={null} />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Stack>
        <Stack direction='row' mb={1}>
          <Box width={200}>
            <Typography
              fontSize={22}
              fontWeight={700}
              color={SettlementsStatusColor[data?.status || 'SELL']}
            >
              {SettlementsStatus[data?.status || 'SELL']}
            </Typography>
          </Box>
          <Box width={300}>
            <Typography fontSize={22} fontWeight={700}>
              {data?.net_amount}
            </Typography>
          </Box>
        </Stack>
        <Stack direction='row' mb={1}>
          <Box width={200}>
            <Typography fontSize={14}>판매 금액</Typography>
          </Box>
          <Box width={300}>
            <Typography fontSize={14} fontWeight={700}>
              {commaNumber(Number(data?.raw_amount))}원
            </Typography>
          </Box>
        </Stack>
        <Stack direction='row' mb={1}>
          <Box width={200}>
            <Typography fontSize={14}>수수료</Typography>
          </Box>
          <Box>
            <Typography fontSize={14} fontWeight={700}>
              {commaNumber(Number(data?.fee_amount))}원
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={14} fontWeight={700} color={color.gray05}>
              ( {(data?.fee_rate || 0) * 100}% )
            </Typography>
          </Box>
        </Stack>
        <Stack direction='row' mb={4}>
          <Box width={200}>
            <Typography fontSize={14}>
              {data?.status === SETTLEMENTS_STATUS.DONE
                ? '지급일'
                : '지급 예정일'}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={14} fontWeight={700}>
              {dayjs(data?.settlement_date).format('YYYY.MM.DD')}
            </Typography>
          </Box>
        </Stack>
        <Stack>
          <Typography fontSize={14} fontWeight={700}>
            {sales?.items.length}명 구매
          </Typography>
        </Stack>
        <Table>
          <Tr>
            <Th>루틴 구매일</Th>
            <Th>닉네임</Th>
            <Th>사용한 프로틴</Th>
            <Th>판매 금액</Th>
          </Tr>
          {sales?.items.map((sale) => (
            <Tr>
              <Td>{dayjs(sale.purchased_at).format('M월 D일 HH:MM')}</Td>
              <Td>{sale.user.nickname}</Td>
              <Td>{commaNumber(sale.consumed_proteins)}</Td>
              <Td>{commaNumber(sale.raw_amount)}원</Td>
            </Tr>
          ))}
        </Table>
      </Container>
    </Box>
  );
}
